<div 
  class="jit-nps-banner-button" 
  (click)="onClick($event)"
  [class.sad]="value < 7"
  [class.normal]="value >= 7 && value <= 8"
  [class.happy]="value > 8"
>
  <span class="jit-nps-banner-button__title">{{ value }}</span>
  <jit-nps-emoji [value]="value"></jit-nps-emoji>
</div>